



















































































import { Component, Vue } from "vue-property-decorator";
import { EditStatus } from "@/types";
import ContactModule from "@/store/contact";
import { NewContact } from "@/api/api";
import { ContactsApi } from "@/services/api-service";
import FormModal from "./FormModal.vue";

@Component({
  components: {
    FormModal,
  },
})
export default class CContactForm extends Vue {
  private get EditStatus() {
    return EditStatus;
  }

  private get editStatus() {
    return ContactModule.editStatus;
  }

  private form: NewContact = {
    name: "",
    email: "",
    title: "",
    content: "",
  };

  private confirm() {
    window.scrollTo(0, 0);
    ContactModule.commitEditStatus(EditStatus.Confirm);
  }

  private backEdit() {
    ContactModule.commitEditStatus(EditStatus.Edit);
  }

  private async submit() {
    try {
      await ContactsApi.instance.postContact(this.form);
      setInterval(() => {
        ContactModule.commitEditStatus(EditStatus.Edit);
      }, 5000);
    } catch (err) {
      console.log(err);
    }
  }

  // ここからモーダル//
  private testShow() {
    (this.$refs.test as FormModal).CtestShow();
    this.submit();
  }
  // ここまでモーダル//
}
